<template>
  <div class="menu-container">
    <el-menu
      background-color="#545c64"
      text-color="#fff"
      active-text-color="#ffd04b"
      :default-active="$route.path"
      :active="$route.path"
      :unique-opened="true"
      class="el-menu-vertical-demo"
    >
      <MenuItem
        v-for="(route, index) in routersList"
        :key="index"
        :item="route"
        :fatherPath="route.path"
      ></MenuItem>
    </el-menu>
  </div>
</template>

<script>
// import routers from "@/router";
import MenuItem from "./MenuItem.vue";
import { getUserInfo } from "@/api/admin-service/user";
import { getMenuTree } from "@/api/admin-service/menu";
import Parent from "@/layouts/components/AppContent";

export default {
  components: {
    MenuItem
  },
  data() {
    return {
      routersList: []
    };
  },
  mounted() {
    // 获取所有定义的一级菜单和多级菜单
    // this.routersList = routers.options.routes[0].children;
    // 获取用户信息
    let access_token = localStorage.getItem("access_token");
    if (access_token) {
      this.getUserInfo();
    }
  },
  methods: {
    getUserInfo() {
      getUserInfo().then(res => {
        const { data } = res || {};
        getMenuTree({
          userId: data.userId
        }).then(r => {
          // 递归函数来处理每个菜单项及其子菜单
          const processMenu = menuItems => {
            return menuItems
              .filter(
                item => !["1C", "2C", "3C", "4C", "5C",'tunnel2c','simple4c','simple1c','icing'].includes(item.menuName)
              )
              .map(item => {
                // 定义当前菜单项的基础结构
                let menu = {
                  path: item.path,
                  meta: {
                    title: item.menuName,
                    oneself: item.children.length === 0,
                    icon: item.icon
                  }
                };
                // 如果有 component，直接使用该 component
                if (item.component) {
                  menu.component = () => import(`@/views${item.component}`);
                } else {
                  // 如果没有 component，使用 Parent 作为默认组件，并处理子菜单
                  menu.component = Parent;
                  if (item.children && item.children.length > 0) {
                    menu.children = processMenu(item.children); // 递归处理子菜单
                  } else {
                    menu.children = []; // 没有子菜单时为空数组
                  }
                }
                return menu;
              });
          };
          const processedMenu = processMenu(r.data);
          this.routersList = processedMenu;
        });
      });
    }
  }
};
</script>
<style lang="less">
.menu-container {
  width: 200px;
  height: 94vh;
  background-color: #545c64;
}
.el-menu {
  border-right: 1px solid transparent !important;
}
</style>
